function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useContext } from 'react';
import { ToggledFeatureKey } from '@domain-group/fe-allhomes-library';
import DomainAdspot from '@domain-group/fe-co-adspot';
import { useAllhomesApi } from '@domain-group/fe-co-allhomes-api-client';
import { AdContext } from './adprovider';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var AdSpot = _ref => {
  var className = _ref.className,
    gpt = _ref.gpt,
    adbridg = _ref.adbridg;
  var _useContext = useContext(AdContext),
    disableAds = _useContext.disableAds;
  var _useAllhomesApi = useAllhomesApi(),
    toggledFeatures = _useAllhomesApi.toggledFeatures;
  if (disableAds) {
    return null;
  }
  if (toggledFeatures[ToggledFeatureKey.ADBRIDG] && adbridg) {
    return ___EmotionJSX("div", {
      className: className,
      id: adbridg.id,
      "data-adbridg-ad-class": adbridg.adClass || adbridg.id
    });
  }
  return ___EmotionJSX(DomainAdspot, _extends({
    className: className
  }, gpt));
};